var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[(_vm.loading)?_c('sr-loading'):_c('div',[_c('sr-top',{attrs:{"data":_vm.DATA}}),_vm._v(" "),_c('sr-param',{attrs:{"data":_vm.DATA}}),_vm._v(" "),_c('sr-content',{attrs:{"data":_vm.DATA}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7a408179","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/list-detail/index.vue
// module id = lpeH
// module chunks = 1